import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { Style } from '@local/client-contracts';
import { isNativeWindow } from '@local/common-web';
import { BrowserBookmarkItem } from '../../models/results-types';
import { getDefaultProfile } from '@shared/utils/set-icon.util';

@Component({
  selector: 'browser-bookmark-item',
  templateUrl: './browser-bookmark-item.component.html',
  styleUrls: ['./browser-bookmark-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrowserBookmarkItemComponent {
  get model(): BrowserBookmarkItem {
    return this._model;
  }
  @Input()
  set model(value: BrowserBookmarkItem) {
    this._model = value;
    this.setIcon();
    this.setPath();
    this.setProfilePicture();
  }

  @Input() selected: boolean;

  private readonly sizeIcon: number = 256;

  private _model: BrowserBookmarkItem;
  profilePicture: Style.EntityIcon<Style.EntityIconType>;
  isNative = isNativeWindow();
  readonly MEMBER_ICON_FALLBACK = getDefaultProfile();

  get showProfileIndication() {
    return this.profilePicture || this.isNative;
  }

  constructor(private cdr: ChangeDetectorRef) {}

  modelIcon: Style.EntityIcon<'font-icon' | 'img'>;
  path: string;

  private setPath() {
    if (this.model.path?.length > 1) {
      this.path = this.model.path.join('/');
    }
  }

  private setIcon() {
    const host = new URL(this.model.url).origin;
    const icon = `https://www.google.com/s2/favicons?domain=${host}&sz=${this.sizeIcon}`;

    this.modelIcon = {
      type: icon ? 'img' : 'font-icon',
      value: icon
        ? {
            lightUrl: icon,
          }
        : 'icon-browser-bookmark',
    };
  }

  private setProfilePicture() {
    if (this.model.profile?.pictureFileName) {
      const value: Style.Icon = { lightUrl: this.model.profile?.pictureFileName };
      this.profilePicture = { type: 'img', value };
      this.cdr.markForCheck();
    }
  }
}
